import { sweepCircleVsSegmentCapsule } from "./_wallcast";

export default function drawCone(g, app, args) {
  const { origin, settings, pxPerMeter, walls, probeRadiusPx } = args;

  const lenPx = Math.max(0, (settings.radiusM ?? settings.radius ?? 3)) * pxPerMeter;
  const baseDeg = Number(settings.rotationDeg ?? 0);
  const spreadDeg = Math.max(0, Number(settings.spreadDeg ?? 30));

  const a0 = (baseDeg - spreadDeg * 0.5) * Math.PI / 180;
  const a1 = (baseDeg + spreadDeg * 0.5) * Math.PI / 180;

  const lineW = Number.isFinite(settings?.lineWidthPx) ? settings.lineWidthPx : 2;
  const probeR = Number.isFinite(probeRadiusPx) ? probeRadiusPx
                 : Number.isFinite(settings?.probeRadiusPx) ? settings.probeRadiusPx
                 : Math.max(0, lineW * 0.5);

  const N = Math.max(12, Math.floor(Number(settings?.samples) || 96));
  const dA = (a1 - a0) / N;

  try { g.lineStyle({ width: lineW, color: 0x00ffff, alpha: 1 }); }
  catch { g.lineStyle(lineW, 0x00ffff, 1); }

  // Outline: left edge → arc → right edge → back to origin
  const edgePts = [];
  for (let i = 0; i <= N; i++) {
    const a = a0 + dA * i;
    const dx = Math.cos(a), dy = Math.sin(a);
    const tx = origin.x + dx * lenPx, ty = origin.y + dy * lenPx;

    let bestT = 1, best = null;
    for (const s of (walls || [])) {
      const h = sweepCircleVsSegmentCapsule(origin.x, origin.y, tx, ty, probeR, s.x1, s.y1, s.x2, s.y2);
      if (h && h.time < bestT) { bestT = h.time; best = h; }
    }

    const px = best ? origin.x + (tx - origin.x) * best.time : tx;
    const py = best ? origin.y + (ty - origin.y) * best.time : ty;
    const sep = best ? Math.max(0.25, probeR * 0.9) : 0;
    edgePts.push({ x: px - (best ? best.nx * sep : 0), y: py - (best ? best.ny * sep : 0) });
  }

  // draw filled outline (optional fill kept subtle)
  try { g.beginFill(0x00ffff, 0.08); } catch {}
  g.moveTo(origin.x, origin.y);
  for (const p of edgePts) g.lineTo(p.x, p.y);
  g.lineTo(origin.x, origin.y);
  try { g.endFill(); } catch {}
}
